




















import Vue from "vue";
import MobileTopBar from "../components/MobileTopBar.vue";
import DesktopTopBar from "../components/DesktopTopBar.vue";
import HabitItem from "../components/HabitItem.vue";
import { mapState } from "vuex";

export default Vue.extend({
  name: "Home",
  components: {
    MobileTopBar,
    DesktopTopBar,
    HabitItem,
  },
  computed: {
    ...mapState({
      habits: "habits",
    }),
  },
  methods: {
    openPage(page: string) {
      this.$router.push(page);
    },
  },
});
